import { View, Text } from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import { gray } from "../../colors";
import translate from "../../functions/translate";

export default function NoTestAvailable() {
  return (
    <View
      style={{
        width: "98%",
        alignItems: "center",

        padding: 5,
        paddingVertical: 15,
        borderRadius: 10,
        marginVertical: 5,
      }}
    >
      <MyText style={{ fontSize: 20, color: gray }}>
        {translate("there is no tests")}
      </MyText>
    </View>
  );
}
